export let APPLIED_ONLY = 'appliedOnly';
export let APPLIED = 'applied';
export let ACTIVE = 'active';
export const DISABLED = 'disabled';
